import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { infoToastAction } from 'utils';
import PropTypes from 'prop-types';

const useSupervisorAccess = (onChange, menu) => {
	const { isSupervisor } = useSelector(globalState => globalState.user);
	const globalDispatch = useDispatch();

	const handleMenu = useCallback(() => {
		if (isSupervisor) {
			onChange(menu);
		} else {
			globalDispatch(infoToastAction('Supervisor access is required'));
		}
	}, [isSupervisor, globalDispatch, onChange, menu]);

	return handleMenu;
};

useSupervisorAccess.propTypes = {
	onChange: PropTypes.func.isRequired,
	menu: PropTypes.string.isRequired
};

export default useSupervisorAccess;
